export enum Role {
  Supervisor = 'Supervisor',
  Admin      = 'Admin',
  CrewLeader = 'Crew Leader',
  Accountant = 'Accountant',
}